<lib-form-field-container [kind]="FormContainerKind.Checkbox">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        @if (isReadOnly) {
            <div
                class="default-content">
                @if (!selectedItemComponents.length) {
                    <ng-container
                        i18n="@@FormFieldNoneSelectedLabel">
                        None selected
                    </ng-container>
                } @else {
                    <div
                        class="d-flex flex-row">
                        @for (item of selectedItemComponents; track item) {
                            <div *ngTemplateOutlet="item.label"></div>
                            <div>{{ $last ? '' : ',&nbsp;' }}</div>
                        }
                    </div>
                }
            </div>
        }
    </ng-container>

    @if (!isReadOnly) {
        <div
            role="group"
            [attr.aria-labelledby]="ariaLabel ? null : formFieldID + '-label'"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
            [attr.aria-label]="ariaLabel || null"
            [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
            [ngClass]="{ 'd-flex flex-wrap': orientation === Orientation.Horizontal }"
            style="width: fit-content">
            @for (item of itemQueryList; track item) {
                <lib-checkbox
                    [formControl]="viewControl.controls[$index]"
                    [isLoading]="isLoading"
                    [qaTag]="item.qaTag"
                    (change)="ChangeEvent()">
                    <ng-container checkboxSupportingText *ngTemplateOutlet="item.supportingText"></ng-container>
                    <ng-container *ngTemplateOutlet="item.label"></ng-container>
                </lib-checkbox>
            }
        </div>
    }
</lib-form-field-container>